import React from "react";
// import Table from "rc-table";
import DataTable, { createTheme } from "react-data-table-component";
import moment from "moment";

import {
  formatName,
  numberWithCommas,
  abbreviateNumber,
} from "helpers/miscHelpers";

function convertToLocalTime(timeText) {
  // const date = new Date(timeText);
  // return date.toString();
  return moment(timeText).format("M/DD h:mma");
}

createTheme("myDark", {
  text: {
    primary: "#ccc",
    secondary: "#2aa198",
  },
  background: {
    default: "rgba(40, 40, 40, 1)",
  },
  context: {
    background: "#cb4b16",
    text: "#FFFFFF",
  },
  divider: {
    default: "rgba(102, 33, 134, 0.4)",
  },
  button: {
    default: "#2aa198",
    hover: "rgba(0,0,0,.08)",
    focus: "rgba(255,255,255,.12)",
    disabled: "rgba(0,0,0,.12)",
  },
  sortFocus: {
    default: "#2aa198",
  },
  highlightOnHover: {
    default: "#EEEEEE",
    text: "rgba(0, 0, 0, 0.87)",
  },
  striped: {
    default: "rgba(60, 60, 60, 0.5)",
    text: "#ccc",
  },
});

const columns = [
  {
    name: "State",
    selector: "name",
    sortable: true,
    format: (row) => row.name,
  },
  // {
  //   name: "Data Quality Grade",
  //   selector: "grade",
  //   sortable: true,
  //   format: (row) => (row.grade ? row.grade : "n/a"),
  //   center: true,
  //   grow: 0,
  // },
  {
    name: "Total Tests",
    selector: "totalTestResults",
    sortable: true,
    format: (row) => `${numberWithCommas(row.totalTestResults)}`,
    right: true,
  },
  {
    name: "Positive Tests",
    selector: "positive",
    sortable: true,
    format: (row) => `${numberWithCommas(row.positive)}`,
    right: true,
    style: { backgroundColor: "rgba(80, 240, 80, 0.1)" },
  },
  {
    name: "Negative Tests",
    selector: "negative",
    sortable: true,
    format: (row) => `${numberWithCommas(row.negative)}`,
    style: { backgroundColor: "rgba(240, 80, 80, 0.1)" },
    right: true,
  },
  {
    name: "Hospitalized (Cumulative)",
    selector: "hospitalizedCumulative",
    sortable: true,
    format: (row) => `${numberWithCommas(row.hospitalizedCumulative)}`,
    right: true,
  },
  {
    name: "Hospitalized (Current)",
    selector: "hospitalizedCurrently",
    sortable: true,
    format: (row) => `${numberWithCommas(row.hospitalizedCurrently)}`,
    right: true,
  },
  {
    name: "Total Deaths",
    selector: "death",
    sortable: true,
    format: (row) => `${numberWithCommas(row.death)}`,
    right: true,
  },
  {
    name: "Last Updated",
    selector: "dateModified",
    sortable: true,
    format: (row) => `${convertToLocalTime(row.dateModified)}`,
    center: true,
  },
];

const customStyles = {
  rows: {
    style: {
      minHeight: "46px", // override the row height
    },
  },
  headCells: {
    style: {
      textAlign: "right",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px", // override the cell padding for data cells
      paddingRight: "8px",
    },
  },
};

const MyDataTable = ({ data }) => (
  <DataTable
    keyField="state"
    columns={columns}
    customStyles={customStyles}
    data={data}
    // title={`Daily Data For: ${latestDate}`}
    striped
    // theme="myDark"
    noHeader
  />
);
export default MyDataTable;
